var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"relative grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3"},[_vm._t("default",null,null,{ onLayout: _vm.onLayout })],2)]),_vm._t("masonry:footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }